import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const EditorInput = ({ value, onChange }: any) => {
  const [editorValue, setEditorValue] = useState(value);

useEffect(() => {
  setEditorValue(value);
}, [value]);

  const handleChange = (newValue: any) => {
    setEditorValue(newValue);
    onChange(newValue);
  };

  const myColors = ["red", "black", "blue", "green", "yellow", "white"];
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ align: ["right", "center", "justify"] }],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link"],
      [{ color: myColors }]
    ]
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "link",
    "color",
    "image",
    "background",
    "align"
  ];
  return (
    <ReactQuill
      theme="snow"
      modules={modules}
      formats={formats}
      value={editorValue}
      onChange={handleChange}
      style={{ height: 600 }}
    />
  );
};

export default EditorInput;
